import { Pagination } from "@mui/material";
import { Row } from "antd";
import { UserContext } from "context/UserContext";
import { useContext, useEffect, useState } from "react";
import { CondominioContextoDTO } from "types/dto/CondominioContextoDTO";
import logoCondominioDefault from "static/cloud21/header/condominio-default.png";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Col } from "react-bootstrap";
import { useGetCondominiosContextoPaginados } from "hooks/condominio/useGetCondominiosContextoPaginados";
import usePostAlterarCondominioContextoToken from "hooks/condominio/usePostAlterarCondominioContextoToken";
import { RequestCondominiosContextoPaginados } from "types/request/RequestCondominiosContextoPaginados";
import showAlert from "shared/util/functions/alert/showAlert";
import { BASE_BUCKET_AWS } from "shared/util/perfis/exportEnvs";

const ListagemSelecaoCondominioContexto = () => {
  const [paginaAtual, setPaginaAtual] = useState<number>(1);

  const {
    usuarioLogado,
    showModalSelecionarCondominioContexto,
    openCloseModalSelecionarCondominioContexto,
    queryCondominioContexto,
  } = useContext(UserContext);

  const params = {
    size: 6,
    page: paginaAtual - 1,
    sort: "pessoaJuridica.nomeFantasia,ASC",
    query: queryCondominioContexto,
  } as RequestCondominiosContextoPaginados;

  const { data: condominiosPage } = useGetCondominiosContextoPaginados(params, showModalSelecionarCondominioContexto);

  const { alterarCondominioContextoToken } = usePostAlterarCondominioContextoToken();

  useEffect(() => {
    setPaginaAtual(1);
  }, [params.query]);

  const changeCondominioContexto = async (condominioId: number) => {
    await alterarCondominioContextoToken(condominioId);
    openCloseModalSelecionarCondominioContexto();
  };

  const renderCardCondominio = (condominio: CondominioContextoDTO, index: number) => {
    let isCondominioSelecionado = usuarioLogado.condominioContextoId == condominio.id;
    return (
      <Row key={`row-condominio-contexto-${index}`}>
        <div
          key={`condominio-contexto-${index}`}
          className="selecionar-condominio condominio-card"
          onClick={() => {
            showAlert({
              titulo: "Atenção",
              texto:
                "Você realmente deseja alterar o Condomínio? Confirmando esta operação você será redirecionado para a página principal do Condomínio selecionado e todo o registro que não foi salvo será desconsiderado.",
              tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
              icon: "warning",
              onConfirm: () => {
                if (condominio.id) {
                  changeCondominioContexto(condominio.id);
                }
              },
            });
          }}
        >
          <Col sm="1" className="center-align">
            <img
              alt="condominio"
              className="client-avatar"
              src={condominio.uuidLogo ? BASE_BUCKET_AWS + condominio.uuidLogo : logoCondominioDefault}
              style={{ height: 30, width: 30 }}
            />
          </Col>
          <Col sm="10" className="header-label">
            {condominio.nomeCondominio || "-"}
          </Col>
          {isCondominioSelecionado && (
            <Col sm="1">
              <FaMapMarkerAlt color="#FF4BA8" fontSize={"1.5em"} />
            </Col>
          )}
        </div>
      </Row>
    );
  };

  const renderPaginacao = () => {
    return (
      <div className={"table-pagination"}>
        <Pagination
          size="small"
          onChange={(_event, paginaAtual) => setPaginaAtual(paginaAtual)}
          page={paginaAtual ?? 0}
          count={condominiosPage?.totalPages ?? 0}
          variant="text"
          shape="rounded"
        />
      </div>
    );
  };

  const renderListaDeCondominios = () => {
    return condominiosPage?.content.map((condominio: CondominioContextoDTO, index: number) => {
      return renderCardCondominio(condominio, index);
    });
  };

  return (
    <>
      {renderListaDeCondominios()}
      {renderPaginacao()}
    </>
  );
};

export default ListagemSelecaoCondominioContexto;
